import { render, staticRenderFns } from "./Comp60t2.vue?vue&type=template&id=738bcb22&scoped=true&"
import script from "./Comp60t2.vue?vue&type=script&lang=js&"
export * from "./Comp60t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp60t2.vue?vue&type=style&index=0&id=738bcb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738bcb22",
  null
  
)

export default component.exports